import { Box, Typography, useTheme, alpha } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { formatInr, formatSessionDate } from "../ptFormat";

/**
 * One closed paper-trade session, for widths where the six-column history grid has to
 * squeeze each column below ~60px. Carries every column the grid shows.
 */
export const SessionHistoryCard = ({ row }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const net = Number(row.netProfit);
  const hasNet = !Number.isNaN(net);
  const netColor = !hasNet
    ? theme.palette.text.secondary
    : net > 0
      ? theme.palette.success.main
      : net < 0
        ? theme.palette.error.main
        : theme.palette.text.secondary;
  const arrow = !hasNet ? "" : net > 0 ? "▲" : net < 0 ? "▼" : "•";

  return (
    <Box
      sx={{
        borderRadius: 2,
        p: 1.25,
        border: `1px solid ${alpha(primary, 0.14)}`,
        borderLeft: `3px solid ${alpha(netColor, 0.85)}`,
        bgcolor: theme.palette.background.paper,
        boxShadow: `0 2px 10px ${alpha("#000", 0.04)}`,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: "0.78rem", fontWeight: 700, whiteSpace: "nowrap" }}>
            {formatSessionDate(row.startDate)}
          </Typography>
          <ArrowForward sx={{ fontSize: 13, color: "text.disabled", flexShrink: 0 }} />
          <Typography sx={{ fontSize: "0.78rem", fontWeight: 700, whiteSpace: "nowrap" }}>
            {formatSessionDate(row.endDate)}
          </Typography>
        </Box>
        <Typography sx={{ fontSize: "0.86rem", fontWeight: 800, color: netColor, whiteSpace: "nowrap" }}>
          {arrow} {formatInr(row.netProfit, { compact: true })}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: 0.75,
          mt: 1,
          pt: 1,
          borderTop: `1px dashed ${alpha(theme.palette.divider, 0.8)}`,
        }}
      >
        {[
          { k: "Utilized", v: formatInr(row.amountUtilized, { compact: true }), c: "text.primary" },
          { k: "Profit", v: formatInr(row.totalProfit, { compact: true }), c: "success.main" },
          { k: "Loss", v: formatInr(row.totalLoss, { compact: true }), c: "error.main" },
        ].map(({ k, v, c }) => (
          <Box key={k} sx={{ minWidth: 0 }}>
            <Typography
              sx={{ fontSize: "0.62rem", color: "text.secondary", fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase" }}
            >
              {k}
            </Typography>
            <Typography noWrap title={v} sx={{ fontSize: "0.78rem", fontWeight: 700, color: c }}>
              {v}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SessionHistoryCard;
